import React from "react";

/** URL รูป placeholder แผนที่ (Wired Google Map) */
const MAP_BG_URL =
  "https://media.wired.com/photos/59269cd37034dc5f91bec0f1/191:100/w_1280,c_limit/GoogleMapTA.jpg";

/** CSS gradient ครึ่งโปร่งใส เพื่อให้เนื้อหาบนแผนที่อ่านได้ง่าย */
const MAP_OVERLAY =
  "linear-gradient(rgba(255,255,255,0.55), rgba(255,255,255,0.55))";

/**
 * MapBackground — กล่องแสดงพื้นหลังแผนที่ (placeholder)
 * รองรับทั้ง URL รูปภาพจริง และ URL ของ File object (URL.createObjectURL)
 *
 * Props:
 *  - imageUrl   : string  — URL รูปที่จะแสดง ถ้าไม่ส่งจะใช้ placeholder
 *  - className  : string  — class เพิ่มเติมสำหรับ wrapper (optional)
 *  - children   : node   — เนื้อหาที่จะแสดงซ้อนบนแผนที่ เช่น pins, toolbar
 */
export default function MapBackground({ imageUrl, className = "", children }) {
  // ถ้ามีรูปจริงให้แสดงตรงๆ, ถ้าไม่มีใช้ placeholder พร้อม overlay
  const backgroundImage = imageUrl
    ? `url(${imageUrl})`
    : `${MAP_OVERLAY}, url(${MAP_BG_URL})`;

  return (
    <div
      className={`bg-cover bg-center ${className}`}
      style={{ backgroundImage }}
    >
      {children}
    </div>
  );
}
